import { createSelector } from 'reselect'
import { StateWithAppNavigation } from '../../types'
import { BottomNavState } from '../types'

// Base selector for the bottom nav draft sub-slice
export const selectBottomNavDraft = (
  state: StateWithAppNavigation
): BottomNavState => state.appNavigation.bottomNavDraft

// Memoized selectors using createSelector for better performance
export const selectNavigationTabsDraft = createSelector(
  [selectBottomNavDraft],
  bottomNav =>
    Object.values(bottomNav.navigation_tabs).sort(
      (a, b) => a.position - b.position
    )
)

// Selector to get a specific tab by ID
export const selectNavigationTabByIdDraft = createSelector(
  [
    selectBottomNavDraft,
    (_state: StateWithAppNavigation, tabId: string | number) => tabId,
  ],
  (bottomNav, tabId) => {
    return bottomNav?.navigation_tabs?.[String(tabId)]
  }
)

// First and last tabs cannot change their label or link
export const selectIsRestrictedTabDraft = createSelector(
  [
    selectBottomNavDraft,
    (_state: StateWithAppNavigation, tabId: string | number) => tabId,
  ],
  (bottomNav, tabId) => {
    const tab = bottomNav.navigation_tabs[String(tabId)]
    if (!tab) return false

    const tabCount = Object.keys(bottomNav.navigation_tabs).length
    // First and last tabs cannot change their label or link
    if (tab.position === 1) return false
    if (tab.position === tabCount) return false
    return true
  }
)

// Selector to check if a tab can be deleted by tabId
export const selectCanDeleteTabDraft = createSelector(
  [
    selectBottomNavDraft,
    (_state: StateWithAppNavigation, tabId: string | number) => tabId,
  ],
  (bottomNav, tabId) => {
    const tab = bottomNav.navigation_tabs[String(tabId)]
    if (!tab) return false

    const tabCount = Object.keys(bottomNav.navigation_tabs).length
    // First and last tabs cannot be deleted
    if (tab.position === 1) return false
    if (tab.position === tabCount) return false
    return true
  }
)
